import React, { useMemo, useRef, useState } from "react";
import { Box, Button, Card, Chip, Grid, Paper, Stack, Table, TableBody, TableContainer, TableHead, TableRow, Typography, LinearProgress } from "@mui/material";
import Highcharts from "highcharts";
import more from "highcharts/highcharts-more";
import HighchartsReact from "highcharts-react-official";
import SolidGauge from "highcharts/modules/solid-gauge";
import HighchartsMore from "highcharts/highcharts-more";
import { useParams } from "react-router-dom";
import { useGetDesignKpiApprovalsQuery, useGetDesignKpiAvgApprovalTimeQuery, useGetDesignKpisQuery } from "store/slices/apis/designEngineeringDashboardSlice";
import { overviewChartPalette } from "styles/theme";
import EngineeringPanelHeader from "./EngineeringPanelHeader";

// Initialize modules
//HighchartsMore(Highcharts);
//SolidGauge(Highcharts);

if (typeof more === "function") {
    more(Highcharts);
}


const EngineeringApprovals = () => {
    const chartRef = useRef(null);
    const { projectId } = useParams();
    const { data, isLoading, error } = useGetDesignKpiApprovalsQuery({ projectId })
    // const { data: avgApprovalData, error: avgError, isLoading: avgLoading } = useGetDesignKpiAvgApprovalTimeQuery({ projectId })
    const { data: avgApprovalData, error: avgError, isLoading: avgLoading } = useGetDesignKpisQuery(projectId);

    if (isLoading) {
        return <Box sx={{
            background: "#fff",
            borderRadius: "3px",
            p: 4,
            boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
            border: "1px solid #E4E4E4",
            textAlign: "center"
        }}>
            <div>Loading Approvals KPIs...</div>
        </Box>
    }


    if (error) {

        console.error("Failed to fetch KPI metrics:", error);
        return (
            <Box sx={{
                background: "#fff",
                borderRadius: "3px",
                p: 4,
                boxShadow: "0px 4px 20px rgba(0,0,0,0.05)",
                border: "1px solid #E4E4E4",
                textAlign: "center"
            }}>
                <div style={{ color: 'red' }}>
                    Error loading data: {error.status} - {error.data?.message || "Please try again."}
                </div>
            </Box>
        );
    }




    const chartOptions = {
        chart: {
            type: "solidgauge",
            height: 150,
        },

        title: null,

        pane: {
            center: ["50%", "60%"],
            size: "100%",
            startAngle: -120,
            endAngle: 120,
            background: [
                {
                    outerRadius: "110%",
                    innerRadius: "92%",
                    backgroundColor: overviewChartPalette.track,
                    shape: "arc",
                },
                // {
                //     outerRadius: "91%",
                //     innerRadius: "73%",
                //     backgroundColor: "#F5F7FF",
                //     shape: "arc",
                // }
            ],
        },


        yAxis: {
            min: 0,
            max: 100,
            lineWidth: 0,
            tickPositions: [],
            overshoot: 90,
            wrap: false,
        },

        plotOptions: {
            solidgauge: {
                linecap: "round",
                stickyTracking: false,
                dataLabels: { enabled: false },
            },
        },

        series: [
            {
                name: "Revision rate",
                rounded: true,
                data: [{
                    y: data?.data?.revisionRate,
                    color: overviewChartPalette.indigo,
                    radius: "110%",
                    innerRadius: "92%"
                }]
            },
            // {
            //     name: "Missed deadline rate",
            //     rounded: true,
            //     data: [{
            //         y: data?.data?.missedDeadlineRate,
            //         color: "#E65F2B",
            //         radius: "91%",
            //         innerRadius: "73%"
            //     }]
            // },


            {
                type: "pie",
                size: "40%",
                innerSize: "100%",
                data: [1],
                dataLabels: {
                    enabled: true,
                    useHTML: true,
                    format: `
                <div style="text-align:center;">
                  <div style="font-size:20px;font-weight:700;color:#343A40;">${data?.data?.totalSubmitted}</div>
                  <div style="font-size:14px;color:#5F666C;font-weight:400;margin-top:-3px;">
                    Submitted
                  </div>
                </div>
              `,
                    distance: -40,
                    borderWidth: 0,
                    backgroundColor: "none",
                    shadow: false,
                },
                enableMouseTracking: false,
            }
        ],

        credits: { enabled: false },
        exporting: { enabled: false },
    };






    // const chartOptions = {

    //     chart: {
    //         type: "solidgauge",
    //         height: 200,
    //         margin: 0,
    //         spacing: [0, 0, 0, 0]
    //     },

    //     title: { text: "" },

    //     pane: {
    //         startAngle: -140,
    //         endAngle: 230,
    //         background: [
    //             {
    //                 outerRadius: "112%",
    //                 innerRadius: "95%",
    //                 backgroundColor: "#FFFFFF",
    //                 borderWidth: 0,
    //                 startAngle: -140,
    //                 endAngle: 230

    //             },
    //             {
    //                 outerRadius: "94%",
    //                 innerRadius: "78%",
    //                 backgroundColor: "#FFFFFF",
    //                 borderWidth: 0,
    //                 startAngle: -140,
    //                 endAngle: 230

    //             },
    //             {
    //                 outerRadius: "77%",
    //                 innerRadius: "61%",
    //                 backgroundColor: "#FFFFFF",
    //                 borderWidth: 0,
    //                 startAngle: -140,
    //                 endAngle: 230

    //             },
    //             {
    //                 outerRadius: "60%",
    //                 innerRadius: "44%",
    //                 backgroundColor: "#FFFFFF",
    //                 borderWidth: 0,
    //                 startAngle: -140,
    //                 endAngle: 230

    //             },
    //         ]
    //     },

    //     yAxis: {
    //         min: 0,
    //         max: 100,
    //         lineWidth: 0,
    //         tickPositions: []
    //     },

    //     plotOptions: {
    //         solidgauge: {
    //             dataLabels: {
    //                 enabled: false,
    //                 y: -50
    //             },
    //             linecap: "round",
    //             size: "250%"
    //         }
    //     },

    //     series: [
    //         {
    //             data: [{
    //                 y: 75,
    //                 color: "#1A73E8",
    //                 radius: "112%",
    //                 innerRadius: "95%"
    //             }]
    //         },
    //         {
    //             data: [{
    //                 y: 55,
    //                 color: "#34C759",
    //                 radius: "94%",
    //                 innerRadius: "78%"
    //             }]
    //         },
    //         {
    //             data: [{
    //                 y: 40,
    //                 color: "#FF8D28",
    //                 radius: "77%",
    //                 innerRadius: "61%"
    //             }]
    //         },
    //         {
    //             data: [{
    //                 y: 30,
    //                 color: "#E65F2B",
    //                 radius: "60%",
    //                 innerRadius: "44%"
    //             }]
    //         },
    //         {
    //             type: 'pie',
    //             size: '30%',
    //             innerSize: '100%',
    //             dataLabels: {
    //                 enabled: true,
    //                 format: '<div style="text-align:center"><span style="font-size:24px;font-weight:bold">432</span><br/><span style="font-size:12px">Submitted</span></div>',
    //                 distance: -50,
    //                 backgroundColor: 'none',
    //                 style: {
    //                     fontWeight: 'normal'
    //                 }
    //             },
    //             data: [1],
    //             enableMouseTracking: false
    //         }
    //     ],
    //     credits: { enabled: false },
    // };

    return (
        <Grid container spacing={"10px"}>

            <Card
                elevation={0}
                sx={{
                    borderRadius: 3,
                    border: "1px solid #E4E4E4",
                    width: '100%',
                }}
            >
                <EngineeringPanelHeader eyebrow="Design assurance" title="Approval Performance" subtitle="Review submission throughput, revision demand, and approval turnaround." />
                <Box sx={{
                    width: '100%',
                    // borderBottom: "1px solid #E4E4E4",
                    py: 1,
                    pb: 0,
                    px: 2,
                    justifyContent: 'space-between',
                    display: 'none'
                }}>
                    <Box>
                        <Typography sx={{ fontSize: "11px", fontWeight: 700, color: overviewChartPalette.indigo, textTransform: "uppercase", letterSpacing: "0.04em" }}>
                            Design assurance
                        </Typography>
                        <Typography sx={{
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 500,
                            fontSize: '20px',
                            letterSpacing: "0px",
                            mb: 0,
                            color: "#111216"
                        }}>
                            Approval Performance
                        </Typography>
                        <Typography sx={{
                            fontFamily: "Poppins, sans-serif",
                            fontWeight: 500,
                            fontSize: '14px',
                            letterSpacing: "0px",
                            color: '#7D7F81'
                        }}>
                            Review submission throughput, revision demand, and approval turnaround.
                        </Typography>
                    </Box>
                </Box>
                <Grid container>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <Box sx={{ flex: 1, p: 1.5, pb: 0, pr: 0 }}>
                            <Box sx={{ mb: 0 }}>
                                <Box sx={{
                                    display: "flex",
                                    gap: "43px",
                                    alignItems: "flex-start"
                                }} >
                                    <Box sx={{ ml: 3 }}>
                                        {/* <Box sx={{ height: "3px", bgcolor: "#1A73E8", width: "113px", borderRadius: "2px" }}> </Box> */}
                                        {/* <Typography

                                        sx={{
                                            fontFamily: "Outfit, sans-serif",
                                            fontWeight: 400,
                                            fontSize: '13px',
                                            letterSpacing: "0px",
                                            mb: "0px",
                                            color: '#34C759'
                                        }}
                                    >
                                        Drawing Approval %
                                    </Typography>
                                    <Typography

                                        sx={{
                                            fontFamily: "Outfit, sans-serif",
                                            fontWeight: 500,
                                            fontSize: '24px',
                                            letterSpacing: "0px",
                                            mb: "15px",
                                            color: "#34C759"
                                        }}
                                    >
                                        78%
                                    </Typography> */}
                                        <Box sx={{ mb: "15px" }}>
                                            <Typography

                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: '13px',
                                                    letterSpacing: "0px",
                                                    mb: "0px",
                                                    color: '#5F6368'
                                                }}
                                            >
                                                Revision Rate
                                            </Typography>
                                            <Typography

                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 500,
                                                    fontSize: '24px',
                                                    letterSpacing: "0px",
                                                    mb: 0,
                                                    color: overviewChartPalette.indigo
                                                }}
                                            >
                                                
                                                {data?.data?.revisionRate || 0}%
                                            </Typography>
                                        </Box>
                                        <Box >
                                            {/* <Typography

                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 400,
                                                    fontSize: '13px',
                                                    letterSpacing: "0px",
                                                    mb: "0px",
                                                    color: '#5F6368'
                                                }}
                                            >
                                                Missed deadline rate %
                                            </Typography>
                                            <Typography

                                                sx={{
                                                    fontFamily: "Outfit, sans-serif",
                                                    fontWeight: 600,
                                                    fontSize: '24px',
                                                    letterSpacing: "0px",
                                                    mb: 0,
                                                    color: "#E65F2B"
                                                }}
                                            >
                                                { data?.data?.missedDeadlineRate || 0 }
                                            </Typography> */}
                                        </Box>
                                    </Box>
                                    {/* <Box sx={{ mb: "15px" }}>
                                    <Typography
                                        sx={{
                                            fontFamily: "Outfit, sans-serif",
                                            fontWeight: 400,
                                            fontSize: '13px',
                                            letterSpacing: "0px",
                                            mb: "0px",
                                            color: '#5F6368'
                                        }}
                                    >
                                        Rejection rate
                                    </Typography>
                                    <Typography

                                        sx={{
                                            fontFamily: "Outfit, sans-serif",
                                            fontWeight: 600,
                                            fontSize: '24px',
                                            letterSpacing: "0px",
                                            mb: 0,
                                            color: "#E65F2B"
                                        }}
                                    >
                                        10%
                                    </Typography>
                                </Box> */}
                                </Box>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid size={{ xs: 12, md: 6 }}>
                        <HighchartsReact highcharts={Highcharts} options={chartOptions} ref={chartRef} />
                    </Grid>
                </Grid>
            </Card>
            <Card elevation={0}
                sx={{
                    borderRadius: 3,
                    border: "1px solid #E4E4E4",
                    width: '100%',
                }}>
                <Grid size={12} sx={{ px: 2.5, py: 1 }}>
                    <Box sx={{ display: 'flex', flexDirection: "column", gap: "7px", justifyContent: "flex-start" }}>
                        <Typography
                            sx={{
                                fontWeight: 600,
                                fontSize: '15px',
                                color: '#6C757D',
                                fontFamily: "Outfit, sans-serif",

                            }} >
                            Average Approval Turnaround
                        </Typography>
                        <LinearProgress
                            variant="determinate"
                            // value={avgApprovalData?.data?.averageApprovalTimeDays || 0}
                            value={avgApprovalData?.data?.averageApprovalTime || 0}
                            sx={{
                                height: 34,
                                borderRadius: "5px",
                                backgroundColor: '#E7E7EB',
                                '& .MuiLinearProgress-bar': {
                                    backgroundColor: "#0096FF",
                                    borderRadius: 0,
                                }
                            }}
                        />
                    </Box>

                </Grid>
            </Card>
        </Grid>
    );
};

export default EngineeringApprovals;
